module.exports = __webpack_public_path__ + "welcome2-b95d89f7a3a2487cd55a8f2e43cd553e.png";